import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	removeDates: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-dates',
		defaultMessage: 'Remove dates',
		description: 'Label for remove dates option',
	},
	removeStartDate: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-start-date',
		defaultMessage: 'Remove start date',
		description: 'Label for remove start date option',
	},
	removeDueDate: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-due-date',
		defaultMessage: 'Remove due date',
		description: 'Label for remove due date option',
	},
	removeBothDates: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-both-dates',
		defaultMessage: 'Remove both dates',
		description: 'Label for remove both dates option',
	},
	requiredDates: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.required-dates',
		defaultMessage: 'Dates are required for this issue',
		description: 'Tooltip for required dates',
	},
	requiredDatesIssueTermRefresh: {
		id: 'business-timeline.timeline-view.list-item-menu-option.remove-dates-option.required-dates-issue-term-refresh',
		defaultMessage: 'Dates are required for this work item',
		description: 'Tooltip for required dates',
	},
});
export default messages;
